import p5 from 'p5';
import { Particle } from './Particle';
import { Wall } from './Wall';

export class IonPainter extends p5 {

  private _walls: Wall[];
  private _particle: Particle;
  private _sceneW = this.windowWidth / 2 - 50;
  private _sceneH = this.windowHeight / 2 - 50;

  constructor (node: HTMLElement) {
    super(() => { /* empty */ }, node);
    this._walls = [];
  }

  private _addCutOffWalls (): void {
    this._walls.push(new Wall(this, 0, 0, this._sceneW, 0));
    this._walls.push(new Wall(this, this._sceneW, 0, this._sceneW, this._sceneH));
    this._walls.push(new Wall(this, this._sceneW, this._sceneH, 0, this._sceneH));
    this._walls.push(new Wall(this, 0, this._sceneH, 0, 0));
  }

  private _isKeyDownAnyDefined (): boolean {
    return this.keyIsDown(87) || this.keyIsDown(83) || this.keyIsDown(65) || this.keyIsDown(68);
  }

  private _createWalls (): void {
    for (let index = 0; index < 5; index++) {
      const x1 = this.random(this._sceneW);
      const x2 = this.random(this._sceneW);
      const y1 = this.random(this._sceneH);
      const y2 = this.random(this._sceneH);
      this._walls.push(new Wall(this, x1, x2, y1, y2));
    }
    this._addCutOffWalls();
  }

  public setup (): void {
    this.createCanvas(this._sceneW * 2, this._sceneH);

    this._createWalls();

    this._particle = new Particle(this, {
      x: this._sceneW / 2,
      y: this._sceneH / 2
    });
  }

  public draw = () => {

    // w
    if (this.keyIsDown(87)) {
      this._particle.move(1);
    }

    // s
    if (this.keyIsDown(83)) {
      this._particle.move(-1);
    }

    // a
    if (this.keyIsDown(65)) {
      this._particle.rotate(-0.05);
    }

    // d
    if (this.keyIsDown(68)) {
      this._particle.rotate(0.05);
    }

    this.background(0);
    for (const wall of this._walls) {
      wall.show();
    }

    // FIXME: moves particel position to mouse postion after key release
    // if (!this._isKeyDownAnyDefined()) {
    this._particle.position(this.mouseX, this.mouseY);
    // }

    this._particle.show();

    const scene = this._particle.look(this._walls);
    const w = this._sceneW / scene.length;

    this.push();
    this.translate(this._sceneW, 0);

    for (let index = 0; index < scene.length; index++) {
      this.noStroke();

      const ssq = scene[index] * scene[index];
      const wsq = this._sceneW * this._sceneW;

      const b = this.map(ssq, 0, wsq, 255, 0);
      const h = this.map(scene[index], 0, this._sceneW, this._sceneH, 0);
      this.fill(0, b, 0);
      this.rectMode(this.CENTER);
      this.rect((index * w) + (w / 2), this._sceneH / 2, w + 1, h);
    }

    this.pop();
  }

  // placeholder method
  public show (): void {
    return;
  }
}
